(function($){
    window.Application = {
        ready: function () {
            this.searchAjax.ready();
            window.screenXL = 1366;
            window.screenLG = 1150;
            window.screenMD = 992;
            window.screenSM = 767;
            window.screenXS = 480;
            window.screenUS = 380;
            window.maxAsideRes = 1700;
            //-------------------------------------------
            //viewport
            function viewport() {
                var e = window, a = 'inner';
                if (!('innerWidth' in window )) {
                    a = 'client';
                    e = document.documentElement || document.body;
                }
                return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
            }
            //-------------------------------------------
            //toggle body class
            function fnToggle(cl,action) {
                var $activeClass = cl,
                    $elClass = $('body');
                if(action=='close'){
                    $elClass.removeClass($activeClass);
                }else{
                    if($elClass.hasClass($activeClass)==true){
                        $elClass.removeClass($activeClass);
                    }else{
                        $elClass.addClass($activeClass);
                    }
                }
            }
            //-------------------------------------------
            //header placeholder
            function fnHeaderPlaceholder(){
                $('#header-placeholder').css('height',$('#header').outerHeight());
            }
            //-------------------------------------------
            //mobile nav
            function fnToggleNav(action) {
                fnToggle('nav-active',action);
            }
            $(document).on('click','#header .nav-toggle',function(e){
                e.preventDefault();
                fnToggleNav();
            });
            //-------------------------------------------
            //search toggle
            function fnToggleSearch(action) {
                fnToggle('search-active',action);
            }
            $(document).on('click','#header .search-toggle',function(e){
                e.preventDefault();
                $('#header .search-field').focus();
                fnToggleSearch();
            });
            $(document).mouseup(function (e) {
                var container = $('#header .search-wrap'),
                    exceptions = $('#header .search-field');
                if (!container.is(e.target) && container.has(e.target).length === 0 && !exceptions.is(e.target)){
                    fnToggleSearch('close');
                }
            });
            //-------------------------------------------
            //top part scrolled
            function fnDesktopFixedNav(el) {
                var $cl = 'page-scrolled';
                if($(window).scrollTop()>0){
                    $('body').addClass($cl);
                }else{
                    $('body').removeClass($cl);
                }
            }
            //-------------------------------------------
            //section aside overflow
            function fnSectionAsideOverflow() {
                var $section = $('.js-section-overflow');
                if($section.length){
                    $section.each(function(){
                        var $this = $(this),
                            $el = $this.find('.js-section-overflow__element'),
                            $container = $this.find('.js-section-overflow__container');
                        if(viewport()['width']>=screenXL){
                            var $containerWidth = $container.width(),
                                $windowWidth = viewport()['width'];
                            if(viewport()['width']>maxAsideRes){
                                $windowWidth = maxAsideRes;
                            }
                            var $space = (($windowWidth - $containerWidth) / 2);
                            if($this.hasClass('js-section-overflow--left')){
                                $el.css('margin-left',-$space);
                            }
                            if($this.hasClass('js-section-overflow-right')){
                                $el.css('margin-right',-$space);
                            }
                        }else{
                            $el.css({
                                marginLeft: '',
                                marginRight: ''
                            });
                        }
                    });
                }
            }
            //-------------------------------------------
            //section shop categories
            slid =  $('.section-woocommerce-categories .woocommerce-products-list').slick({
                arrows: true,
                autoplaySpeed: 1000,
                centerMode: true,
                centerPadding: '0',
                dots: false,
                draggable: false,
                outerEdgeLimit: true,
                infinite: true,
                prevArrow: '<a class="nav-prev"><span class="img"></span></a>',
                nextArrow: '<a class="nav-next"><span class="img"></span></a>',
                slidesToShow: 5,
                speed: 500,
                swipe: true,
                variableWidth: true,
                responsive: [{
                    breakpoint: 1580,
                    settings: {
                        slidesToShow: 3
                    }
                },{
                    breakpoint: 1030,
                    settings: {
                        slidesToShow: 1
                    }
                }]
            });
            //-------------------------------------------
            //?????????
            function fnProductDetailOverflow() {
                var $section = $('.woocommerce-product .single-product');
                if($section.length){
                    $section.each(function(){
                        var $el = $(this),
                            $gallery = $el.find('.woocommerce-product-gallery'),
                            $container = $el.find('.woocommerce-product-container');
                        if(viewport()['width']>screenXL){
                            var $containerWidth = $container.width(),
                                $windowWidth = viewport()['width'];
                            if(viewport()['width']>maxAsideRes){
                                $windowWidth = maxAsideRes;
                            }
                            var $space = (($windowWidth - $containerWidth) / 2);
                            $gallery.css('margin-left',-$space);
                        }else{
                            $gallery.css({
                                marginLeft: ''
                            });
                        }
                    });
                }
            }
            //-------------------------------------------
            //carousel with overflow right
            $('.js-slider-right .slider').each(function(){
                var $slider = $(this),
                    $parent = $slider.closest('.js-slider-right'),
                    $arrowsWrap = $parent.find('.slider-navs'),
                    $autoplay = false;
                if($parent.hasClass('js-slider-right--autoplay')){
                    $autoplay = true;
                }
                $slider.slick({
                    arrows: true,
                    autoplay: $autoplay,
                    autoplaySpeed: 1000,
                    cssEase: 'ease',
                    dots: false,
                    draggable: false,
                    infinite: true,
                    appendArrows: $arrowsWrap,
                    prevArrow: '<a class="nav-prev"><i class="icon-arrow-left"></i></a>',
                    nextArrow: '<a class="nav-next"><i class="icon-arrow-right"></i></a>',
                    speed: 1000,
                    swipe: true,
                    variableWidth: true
                });
            });
            function fnSectionResponsibility() {
                var $section = $('.js-slider-right');
                if($section.length){
                    $section.each(function(){
                        var $el = $(this),
                            $slider = $el.find('.slider-wrap'),
                            $container = $el.find('.section-inner');
                        if(viewport()['width']>screenXL){
                            var $containerWidth = $container.width(),
                                $windowWidth = viewport()['width'];
                            var $space = (($windowWidth - $containerWidth) / 2);
                            $slider.css('margin-right',-$space);
                        }else{
                            $slider.css({
                                marginRight: ''
                            });
                        }
                    });
                }
            }
            $('.js-slider-right .item > *').matchHeight();
            //-------------------------------------------
            //slider aligned to center
            $('.js-slider-center .slider').each(function(){
                var $slider = $(this);
                $slider.slick({
                    arrows: true,
                    autoplaySpeed: 1000,
                    dots: false,
                    draggable: false,
                    infinite: true,
                    fade: false,
                    prevArrow: '<a class="nav-prev"><i class="icon-arrow-left"></i></a>',
                    nextArrow: '<a class="nav-next"><i class="icon-arrow-right"></i></a>',
                    speed: 500,
                    swipe: true
                });
            });
            //-------------------------------------------
            //section split media overflow
            function fnSectionSplitMedia() {
                var $section = $('.section-split');
                if($section.length){
                    $section.each(function(){
                        var $el = $(this),
                            $media = $el.find('.media-wrap'),
                            $container = $el.find('.section-inner');
                        if(viewport()['width']>screenXL){
                            var $containerWidth = $container.width(),
                                $windowWidth = viewport()['width'];
                            if(viewport()['width']>maxAsideRes){
                                $windowWidth = maxAsideRes;
                            }
                            var $space = (($windowWidth - $containerWidth) / 2);
                            if($el.hasClass('media-left')){
                                $media.css('margin-left',-$space);
                            }
                            if($el.hasClass('media-right')){
                                $media.css('margin-right',-$space);
                            }
                        }else{
                            $media.css({
                                marginLeft: '',
                                marginRight: ''
                            });
                        }
                    });
                }
            }
            //-------------------------------------------
            //article gallery
            $('.article-full .gallery').magnificPopup({
                delegate: 'a',
                type: 'image',
                closeOnContentClick: false,
                closeBtnInside: false,
                image: {
                    verticalFit: true
                },
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0,1],
                    tCounter: '%curr%/%total%'
                }
            });
            //-------------------------------------------
            //product gallery
            $('.woocommerce-product-gallery').magnificPopup({
                delegate: 'a',
                type: 'image',
                closeOnContentClick: false,
                closeBtnInside: false,
                image: {
                    verticalFit: true
                },
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0,1],
                    tCounter: '%curr%/%total%'
                }
            });
            //-------------------------------------------
            //product filter accordion
            $('.widget-woof .widget-title').each(function(){
                var $this = $(this),
                    $elHeading = $this,
                    $elContainer = $this.next();
                $elHeading.removeClass('active')
                $elContainer.hide();
                $elHeading.on('click', function () {
                    if(viewport()['width']<screenSM) {
                        if ($(this).hasClass('active')) {
                            $(this).next().slideUp('fast');
                            $(this).removeClass('active');
                        } else {
                            $elHeading.removeClass('active')
                            $elContainer.slideUp('fast');
                            $(this).next().slideDown('fast');
                            $(this).addClass('active');
                        }
                    }
                });
            });
            //-------------------------------------------
            //tabs
            $('.js-tabs a').on('click',function(e){
                e.preventDefault();
                var $el = $(this),
                    $tab = $el.parent(),
                    $panelId = $tab.data('tab'),
                    $panel = $('#'+$panelId),
                    $clActive = 'active';
                if(!$tab.hasClass($clActive)){
                    $tab.siblings('.'+$clActive).removeClass($clActive);
                    $tab.addClass($clActive);
                    $panel.siblings('.'+$clActive).removeClass($clActive);
                    $panel.addClass($clActive);
                }
            });
            //-------------------------------------------
            //section appears
            $(window).on('load',function(){
                $('.js-section-appear').addClass('section-home-hero--appears')
            });
            //-------------------------------------------
            //blog popular - items height ie fix
            $('.page-template-page-blog .section-blog-popular .title').matchHeight();
            // -------------------------------------------
            //triggers
            fnDesktopFixedNav();
            fnSectionSplitMedia();
            fnProductDetailOverflow();
            fnSectionResponsibility();
            fnHeaderPlaceholder();
            fnSectionAsideOverflow();
            $(window).on('load',function(){
                fnDesktopFixedNav();
                fnSectionSplitMedia();
                fnProductDetailOverflow();
                fnSectionResponsibility();
                fnHeaderPlaceholder();
                fnSectionAsideOverflow();
            });
            $(window).resize(function(){
                fnDesktopFixedNav();
                fnSectionSplitMedia();
                fnProductDetailOverflow();
                fnSectionResponsibility();
                fnHeaderPlaceholder();
                fnSectionAsideOverflow();
            });
            $(window).scroll(function(){
                fnDesktopFixedNav();
            });
            $(document).keyup(function(e) {
                if (e.keyCode === 27){
                    fnToggleNav('close');
                    fnToggleSearch('close');
                }
            });
            //-------------------------------------------
            /* popup */
            $('.js-video-popup').magnificPopup({
                type: 'iframe',
                iframe: {
                    patterns: {
                        youtube: {
                            index: 'youtube.com/',
                            id: function(url) {
                                var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/);
                                if ( !m || !m[1] ) return null;
                                return m[1];
                            },
                            src: '//www.youtube.com/embed/%id%?autoplay=1'
                        }
                    }
                }
            });
            //-------------------------------------------
            //home hero
            function fnHomeHero(){
                var $clMain = 'js-home-hero',
                    $clTrigger = 'item-title',
                    $clContent = 'item-content',
                    $clActive = 'active';
                $('.'+$clMain+' .'+$clTrigger).hover(function(){
                    var $this = $(this),
                        $el = $this.siblings('.'+$clContent);
                    if($el.hasClass($clActive)==false){
                        $el.addClass($clActive);
                        $el.fadeIn();
                    }
                },function(){
                    var $this = $(this),
                        $el = $this.siblings('.'+$clContent);
                    $el.fadeOut('fast',function(){
                        $el.removeClass($clActive);
                    });
                });


            }
            function fnHomeHeroScroll(){
                if(viewport()['width']>screenSM){
                    $('.section-home-hero .scrollbar-inner').scrollbar('destroy');
                }else{
                    $('.section-home-hero .scrollbar-inner').scrollbar();
                }
            }
            fnHomeHero();
            fnHomeHeroScroll();
            $(window).resize(function(){
                fnHomeHeroScroll();
            });
            //-------------------------------------------
            //product detail
            function fnProdCat(){
                var $clMain = 'js-product-full',
                    $clTrigger = 'item-title',
                    $clContent = 'item-content',
                    $clImageSrc = 'item-image-img',
                    $clImageDest = 'image-img',
                    $clActie = 'active';
                $('.'+$clTrigger).on('click',function(){
                    var $this = $(this),
                        $content = $this.siblings('.'+$clContent);
                    if($this.hasClass($clActie)){
                        $content.slideUp();
                        $this.removeClass($clActie);
                    }else{
                        var $activeTitle = $('.'+$clMain+' .'+$clTrigger+'.'+$clActie),
                            $activeContent = $activeTitle.siblings('.'+$clContent);
                            //$newImageSrc = $content.find('.'+$clImageSrc).attr('src');
                        $activeContent.slideUp();
                        $activeTitle.removeClass($clActie);
                        // $('.'+$clImageDest).attr('src',$newImageSrc);
                        $content.slideDown();
                        $this.addClass($clActie);
                    }
                });
            }
            fnProdCat();
            //-------------------------------------------
            //article tables
            $('.article-full table').each(function(){
                $(this).wrap('<div class="table-overflow">');
            });
            //-------------------------------------------
        }
    };
})(jQuery);

// Initiate the application
jQuery(function () {
    Application.ready();
});